export default "__VITE_ASSET__C5Vk75n4__"